import simpleSoilAttribute from './simpleSoilAttribute';

export const FLOODING_FREQUENCY_CLASS = simpleSoilAttribute({
  key: 'Flooding Frequency Class',
  ruleId: '12',
  shortFormData: {
    AggregationMethod: 'Dominant Condition',
    BeginningMonth: 'January',
    EndingMonth: 'December',
  },
});
